import {Link} from "react-router-dom";
const MainMenu = () => {
    return(
        <nav id="topheader" className="d-none d-lg-block navbar navbar-expand-lg justify-content-start py-0 pl-60 pl-lg-0">
            <ul className="navbar-nav list-style-none">
                <li className="nav-item dropdown active">
                    <a className="nav-link dropdown-toggle" to="index" id="navbarDropdown2"
                        role="button" data-bs-toggle="dropdown" aria-expanded="false">Home <i className="fal fa-chevron-down"></i></a>
                    <ul className="dropdown-menu">
                        <li className="dropdown-submenu">
                            <a className="dropdown-item dropdown-toggle" to="services"
                                id="navbarDropdow2a" role="button" data-bs-toggle="dropdown"
                                aria-expanded="false">Multipage <i
                                    className="fal fa-chevron-down"></i></a>
                            <ul className="dropdown-menu dropdown-menu2"
                                aria-labelledby="navbarDropdown2a">
                                <li>                                   
                                    <Link className="dropdown-item" to="/">Home Style 1</Link>
                                </li>
                                <li>
                                    <Link className="dropdown-item" to="/home-2">Home Style 2</Link>
                                </li>
                                <li>
                                    <Link className="dropdown-item" to="/home-3">Home Style 3</Link>
                                </li>
                                <li>
                                    <Link className="dropdown-item" to="/home-4">Home Style 4</Link>
                                </li>
                                <li>
                                    <Link className="dropdown-item" to="/home-5">Home Style 5</Link>
                                </li>
                               
                            </ul>
                        </li>

                        <li className="dropdown-submenu">
                            <a className="dropdown-item dropdown-toggle" to="services"
                                id="navbarDropdow2a" role="button" data-bs-toggle="dropdown"
                                aria-expanded="false">Onepages <i
                                    className="fal fa-chevron-down"></i></a>
                            <ul className="dropdown-menu dropdown-menu2"
                                aria-labelledby="navbarDropdown2a">
                                <li>
                                    <Link className="dropdown-item" to="/onepage-1">Onepage Style 1</Link>
                                </li>
                                <li>
                                    <Link className="dropdown-item" to="/onepage-2">Onepage Style 2</Link>
                                </li>
                                <li>
                                    <Link className="dropdown-item" to="/onepage-3">Onepage Style 3</Link>
                                </li>                             
                               
                            </ul>
                        </li>
                        
                    </ul>
                </li>
                <li className="nav-item">
                    <Link className="nav-link" to="/about">About</Link>
                </li>
                <li className="nav-item dropdown">
                    <a className="nav-link dropdown-toggle" to="#" id="navbarDropdow2" role="button"
                        data-bs-toggle="dropdown" aria-expanded="false">Services <i className="fal fa-chevron-down"></i></a>
                    <ul className="dropdown-menu">
                        <li>
                            <Link className="dropdown-item" to="/services">Services</Link>
                        </li>
                        <li>
                            <Link className="dropdown-item" to="/services-details">Services
                                Details</Link>
                        </li>
                    </ul>
                </li>
                <li className="nav-item dropdown">
                    <Link className="nav-link dropdown-toggle" to="#" id="navbarDropdown4" role="button"
                        data-bs-toggle="dropdown" aria-expanded="false">Pages <i className="fal fa-chevron-down"></i></Link>
                    <ul className="dropdown-menu" aria-labelledby="navbarDropdown4">
                        <li>
                            <Link className="dropdown-item" to="/team">Team</Link>
                        </li>
                        <li>
                            <Link className="dropdown-item" to="/team-details">Team Details</Link>
                        </li>
                        <li>
                            <Link className="dropdown-item" to="/portfolio">Portfolio</Link>
                        </li>
                        <li>
                            <Link className="dropdown-item" to="/case-details">Case Details</Link>
                        </li>
                        <li>
                            <Link className="dropdown-item" to="/price">Pricing</Link>
                        </li>
                        <li>
                            <Link className="dropdown-item" to="/history">Our History</Link>
                        </li>
                        <li>
                            <Link className="dropdown-item" to="/faq">Faq</Link>
                        </li>
                    </ul>
                </li>
                <li className="nav-item dropdown">
                    <Link className="nav-link dropdown-toggle" to="#" id="navbarDropdown5"
                        role="button" data-bs-toggle="dropdown" aria-expanded="false">News <i className="fal fa-chevron-down"></i></Link>
                    <ul className="dropdown-menu" aria-labelledby="navbarDropdown5">
                        <li>
                            <Link className="dropdown-item" to="/news">News</Link>
                        </li>
                        <li>
                            <Link className="dropdown-item" to="/news-details">News Details</Link>
                        </li>
                    </ul>
                </li>
                <li className="nav-item">
                    <Link className="nav-link" to="/contact">Contact</Link>
                </li>
            </ul>
        </nav>
    )
}
export default MainMenu